import { render, staticRenderFns } from "./AddRemovePageElement.vue?vue&type=template&id=2455b936&scoped=true&"
import script from "./AddRemovePageElement.vue?vue&type=script&lang=js&"
export * from "./AddRemovePageElement.vue?vue&type=script&lang=js&"
import style0 from "./AddRemovePageElement.vue?vue&type=style&index=0&id=2455b936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455b936",
  null
  
)

export default component.exports